import { useState, useRef, useEffect } from "react";
import { FireIcon } from "@heroicons/react/24/outline";
import "./App.css";

export default function WojakChat() {
  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: "Wassup anon, it’s Wojak 🚬 — your degen buddy riding this bullrun like a wave. I don’t cope, I don’t cry, I just meme, ape, and laugh my way through charts. Let’s talk pump, vibes, and pure degen fun. 🚀",
    },
  ]);
  const [input, setInput] = useState("");
  const containerRef = useRef(null);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { from: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);

    try {
      const res = await fetch("https://openrouter.ai/api/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer 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",
          "HTTP-Referer": "http://localhost:3000",
        },
        body: JSON.stringify({
          model: "openai/gpt-4o",
          messages: [
            {
              role: "system",
              content:
                "You are Wojak — the fun-loving, bullish degen mascot of crypto Twitter. You never whine or cry; instead, you celebrate chaos, laugh at rugs, and hype every pump. You speak like a degen in a bullrun: sarcastic, cocky, funny, but always bullish. You drop meme slang, troll anons, and keep the vibes fun and reckless. You are the Wojak who lives for bull markets, FOMO energy, and pure CT banter.",
            },
            { role: "user", content: input },
          ],
        }),
      });

      const data = await res.json();
      console.log("DEBUG:", data);

      const reply = data.choices?.[0]?.message?.content;
      if (reply) {
        setMessages((prev) => [...prev, { from: "bot", text: reply }]);
      } else {
        setMessages((prev) => [
          ...prev,
          {
            from: "bot",
            text: "Bruh… that question was more rugged than a meme with 0 likes. Try again, degen.",
          },
        ]);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setMessages((prev) => [
        ...prev,
        {
          from: "bot",
          text: "Connection rugged harder than shorts in a bullrun. Reload, anon.",
        },
      ]);
    }

    setInput("");
  };

  useEffect(() => {
    containerRef.current?.scrollTo({
      top: containerRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [messages]);

  return (
    <div className="chat-wrapper">
      <div className="chat-header">
        <div className="chat-avatar wojak-avatar" />
        <div className="chat-title">Wojak</div>
      </div>
      <div ref={containerRef} className="chat-body">
        {messages.map((m, i) => (
          <div
            key={i}
            className={`message ${
              m.from === "user" ? "message-user" : "message-ai"
            }`}
          >
            {m.text}
          </div>
        ))}
      </div>
      <div className="chat-footer">
        <input
          className="chat-input"
          placeholder="Ask Wojak... let’s send it 🚀"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button onClick={sendMessage} className="chat-send">
          <FireIcon className="send-icon" />
        </button>
      </div>
    </div>
  );
}
